import { z } from 'zod';
import { IsoDateTime, UuidString } from '../../primitives.js';
import { FieldType } from './field-definition.js';

/**
 * FieldTemplate — workspace-level shared definition. Attach в проект через
 * `POST /api/v1/projects/:id/field-definitions/from-template` — создаёт
 * FieldDefinition с template_id-ссылкой обратно.
 *
 * Примеры workspace-templates (создаются admin'ом):
 *   - «Смена» (single_select: morning/evening/night)
 *   - «Cost center» (entity_ref)
 *   - «Срочность доставки» (single_select)
 *
 * См. `docs/STAITER_UX.md` §11.21 и `docs/backlogs/task-module/be-backlog.md` BE-S12.1-6.
 */

export const FieldTemplate = z.object({
  id: UuidString,
  entity_id: UuidString,
  key: z
    .string()
    .min(1)
    .max(40)
    .regex(/^[a-z][a-z0-9_]*$/, 'key должен быть snake_case'),
  label: z.string().min(1).max(100),
  type: FieldType,
  required: z.boolean(),
  default_value: z.unknown().nullable(),
  constraints: z.record(z.string(), z.unknown()),
  description: z.string().max(500).nullable(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type FieldTemplate = z.infer<typeof FieldTemplate>;
